import { Alert, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Card, CardBody, CardHeader, Checkbox, Container, Flex, FormControl, FormLabel, Grid, IconButton, Image, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Stack, Text, Textarea, useColorModeValue, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStateContext } from '../../context/ContextProvider';
import axiosClient from '../../axios-client';
import { DeleteIcon, EditIcon, SearchIcon } from '@chakra-ui/icons';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { PiPlusBold } from 'react-icons/pi';
import empty from '../../assets/images/bell.png'
import animationData from '../../assets/lotties/notif.json'
import Lottie from 'react-lottie';
import { useTranslation } from 'react-i18next';
import MyPagination from '../../components/MyPagination';
import { useDebounce } from '../../hooks/useDebounce';


function UserNotifications() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const [loadingData, setLoadingData] = useState()

    const { user, setUser, setCount, setToken, currentBusiness } = useStateContext();
    const [notificationsData, setNotificationsData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [id, setId] = useState(null);
    const toast = useToast()
    const cancelRef = React.useRef()
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [message, setMessage] = useState('');
    const [notifData, setNotifData] = useState();
    const [notifId, setNotifId] = useState('');

    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const [selectedCible, setSelectedCible] = useState(null);
    const [selectedC, setSelectedC] = useState('');
    const [checkLengthData, setCheckLengthData] = useState(false)
    const [date, setDate] = useState("")

    //search variable
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [changeModal, setChangeModal] = useState(true)

    const [selectedIds, setSelectedIds] = useState([]);
    const [isBulkAlert, setIsBulkAlert] = useState(false);

    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setIsBulkAlert(false);
    };

    const handleCibleChange = (ev) => {
        setSelectedCible(ev.target.value)

    }
    const [paginationData, setPaginationData] = useState()

    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        setSelectedIds([]);
    }, [pageSize, currentPage, searchTerm, date]);


    //get the data
    const fetchData = useCallback(async (signal) => {
        if (!user?.id) return;
        try {
            setLoadingData(true);
            const response = await axiosClient.get(
                `/notifications/getUserNotifs/?page_size=${pageSize}&page=${currentPage + 1}&userRole=${user?.role}&userId=${user?.id}&search_term=${debouncedSearchTerm}&date=${date}&business=${currentBusiness?.id}`,
                { signal }
            );
            let filteredData = response.data.results?.notifs || [];
            setPaginationData(response.data);

            if (filteredData.length === 0) {
                setNotificationsData([]);
                setCheckLengthData(true);
            } else {
                setNotificationsData(filteredData);
                setCheckLengthData(false);
            }

            if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
            }
        } catch (error) {
            if (error.name !== 'CanceledError' && error.message !== 'canceled') {
                // console.error(error);
            }
        } finally {
            setLoadingData(false);
        }
    }, [pageSize, currentPage, debouncedSearchTerm, user?.id, user?.role, date, setUser, setToken, toast, t]);

    const updateCounts = useCallback(async () => {
        if (!user?.id) return;
        try {
            const res = await axiosClient.get(`notifications/getUserNotifs/?page_size=7&page=1&userRole=${user.role}&userId=${user.id}`);
            setCount(res.data.results.count);
        } catch (error) {
            // console.error(error);
        }
    }, [user?.id, user?.role, setCount]);

    useEffect(() => {
        const abortController = new AbortController();
        if (user?.id) {
            fetchData(abortController.signal);
        }
        return () => abortController.abort();
    }, [fetchData, user?.id]);

    function update() {
        fetchData();
        updateCounts();
    }
    const IsReadNotif = (id) => {
        axiosClient.get(`/notifications/${id}/`)
            .then((response) => {
                const notification = response.data;

                if (!notification.is_read.includes(user.id)) {
                    notification.is_read.push(user.id);

                    axiosClient.put(`/notifications/${id}/`, {
                        ...notification,
                        is_read: notification.is_read,
                    })
                        .then((response) => {
                            update()
                        })
                        .catch((error) => {
                            // // console.error(error)
                        });
                }
            })
            .catch((error) => {
                // // console.error(error)
            });

    };

    const handleDelete = (notifId) => {
        if (!notifId) return;
        axiosClient.delete(`/notifications/${notifId}/`)
            .then((response) => {
                setNotificationsData((prevData) => prevData.filter((row) => row.id !== notifId));
                update();
                toast({
                    description: t("la notification est supprimée avec succès"),
                    status: 'warning',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right',
                    variant: 'left-accent',
                })
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }

    const handleBulkDelete = () => {
        if (selectedIds.length === 0) return;
        axiosClient.post('/notifications/bulk_delete/', { ids: selectedIds })
            .then((response) => {
                setNotificationsData((prevData) => prevData.filter((row) => !selectedIds.includes(row.id)));
                setSelectedIds([]);
                toast({
                    description: t("Les notifications sélectionnées ont été supprimées avec succès"),
                    status: 'warning',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right',
                    variant: 'left-accent',
                })
                update()
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }

    const myColor = useColorModeValue("white", "gray.700");
    const borderColor = useColorModeValue("gray.300", "gray.600");

    const hoverDeleteBtn = useColorModeValue("red.50", "gray.600");
    const DeleteBtnIcon = useColorModeValue("red.400", "red.300");

    return (
        <Box position={"relative"}>

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Breadcrumb fontStyle={"normal"} fontSize={{ base: "14px", sm: "14px", lg: "15px" }} color="gray.400" letterSpacing="-0.01em">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink >{t("Mes notifications")}</BreadcrumbLink>
                        </BreadcrumbItem>

                    </Breadcrumb>
                </Box>

            </Flex>
            {(notificationsData.length === 0 && !searchTerm && !selectedC && !date) ? (
                <Flex mb={'10'} mt={20} flexDirection={'column'} align={'center'} justify={'center'}>
                    <Image
                        height={150} width={150}
                        rounded={'md'}
                        alt={'empty'}
                        src={
                            empty
                        }
                        objectFit={'empty'}
                    />
                    <Text mt={10} color={"#aeaeae"}>{t("Il n'y a pas de notifications à afficher")}</Text>
                </Flex>) :



                <Flex
                    direction={{ base: 'column', md: 'row' }}
                    align={{ base: 'stretch', md: 'center' }}
                    justify={'center'}
                    p={{ base: 1, sm: 5 }}
                    gap={10}
                >

                    <Flex
                        direction="column"
                        justify={{ base: 'flex-start', md: 'space-between' }}
                        width={{ base: "100%", lg: "70%" }}
                    >
                        <Flex

                            // px={5}
                            justifyContent="end"
                            alignItems="center"
                            direction={{ base: 'column', md: 'row' }}
                            mb={{ base: 2, md: 4 }}
                        >
                            <Input mr={{ base: 0, md: 5 }} mb={4} borderRadius={"5"} borderColor={borderColor} onChange={e => {
                                setCurrentPage(0);
                                setDate(e.target.value);
                            }} w={{ base: '100%', md: '30%' }} placeholder={t("Select Date")} size='md' type='month' />

                            <InputGroup w={{ base: '100%', md: "40%" }}>
                                <InputLeftElement
                                    pointerEvents='none'
                                    children={<SearchIcon color='gray.300' />}
                                />
                                <Input
                                    borderColor={borderColor}
                                    borderRadius={"5"}
                                    placeholder={t("Recherche...")}
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setCurrentPage(0)
                                        setSearchTerm(e.target.value)
                                    }}
                                    mb={4}
                                    sx={{
                                        marginLeft: 'auto',
                                    }}
                                />  </InputGroup>

                        </Flex>

                        {(notificationsData.length > 0) && (
                            <Flex align="center" justify="space-between" mb={4} px={2}>
                                <Checkbox
                                    isChecked={notificationsData.length > 0 && selectedIds.length === notificationsData.length}
                                    isIndeterminate={selectedIds.length > 0 && selectedIds.length < notificationsData.length}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setSelectedIds(notificationsData.map(row => row.id));
                                        } else {
                                            setSelectedIds([]);
                                        }
                                    }}
                                    colorScheme="purple"
                                >
                                    {t("Tout sélectionner")}
                                </Checkbox>
                                {selectedIds.length > 0 && (
                                    <Button
                                        size="sm"
                                        colorScheme="red"
                                        leftIcon={<DeleteIcon />}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setIsBulkAlert(true);
                                            onOpenAlert();
                                        }}
                                    >
                                        {t("Supprimer sélection")} ({selectedIds.length})
                                    </Button>
                                )}
                            </Flex>
                        )}

                        {(notificationsData.length > 0) &&
                            notificationsData.map((row) => (

                                <Stack
                                    bg={myColor}
                                    mb={4}
                                    rounded={'lg'}
                                    p={6}
                                    boxShadow={'md'}
                                    alignItems={'start'}
                                    justify="space-between"
                                    // as={"Button"}
                                    onClick={() => {
                                        IsReadNotif(row.id)
                                        navigate(`/detail-notification`, {
                                            state: {
                                                idNotif: row.id
                                            }
                                        })
                                    }}
                                    cursor={"pointer"} transition={"transform .4s"} _hover={{
                                        shadow: "md",
                                        transform: "scale(1.01)",
                                    }} shadow={'none'}


                                >
                                    <Flex direction="row"
                                        justify="space-between"
                                        ml={'auto'}
                                        width="full">
                                        <Stack display={'flex'} flexDirection={{ base: "column", md: "row" }} align={'center'} flex={1} minW={0} mr={4}>
                                            <Box onClick={(e) => e.stopPropagation()}>
                                                <Checkbox
                                                    isChecked={selectedIds.includes(row.id)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setSelectedIds(prev => [...prev, row.id]);
                                                        } else {
                                                            setSelectedIds(prev => prev.filter(id => id !== row.id));
                                                        }
                                                    }}
                                                    mr={3}
                                                    colorScheme="purple"
                                                />
                                            </Box>
                                            <Text fontSize={'lg'} fontWeight="semibold" noOfLines={1} flex={1} minW={0}>{row.title}</Text>
                                        </Stack>
                                        <Flex align={"center"} flexWrap={"wrap"} gap={2} justifyContent="flex-end">
                                            <Badge
                                                px={3}
                                                py={1}
                                                rounded={'lg'}
                                                width="max-content"
                                                colorScheme={row.cible === "Manager" ? "blue" :
                                                    row.cible === "RespoSuivi" ? "green" :
                                                        row.cible === "StockManager" ? "yellow" :
                                                            row.cible === "All" ? "pink" :
                                                                row.cible === "AdminClient" ? "purple" : ""}
                                            >
                                                {row.cible === "Manager" ? "Manager" :
                                                    row.cible === "RespoSuivi" ? t("Call center") :
                                                        row.cible === "StockManager" ? `Stock Manager ` :
                                                            row.cible === "All" ? `All ` :
                                                                row.cible === "AdminClient" ? "Client" : ""}
                                            </Badge>
                                            {row.business_name && (
                                                <Badge px={3} py={1} rounded={'lg'} width="max-content" colorScheme="teal">
                                                    {row.business_name}
                                                </Badge>
                                            )}
                                            <Text fontSize={'xs'} color={'gray.500'}>{new Date(row.date_creation).toLocaleDateString(t('fr-FR'), { hour: '2-digit', minute: '2-digit' })}</Text>
                                            <Stack
                                                color={DeleteBtnIcon}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setId(row.id);
                                                    setIsBulkAlert(false);
                                                    onOpenAlert();
                                                }}
                                                cursor='pointer'
                                                p={3}
                                                rounded={"full"}
                                                _hover={{ bg: hoverDeleteBtn }}
                                                ml={2}
                                            >
                                                <DeleteIcon size="sm" />
                                            </Stack>
                                        </Flex>

                                    </Flex>

                                    <Flex
                                        direction="row"
                                        width="full"
                                        ml={'auto'}
                                        justify="space-between">
                                        <Text fontSize={{ base: 'sm' }} textAlign={'justify'} w={"100%"}>
                                            {row.content.substring(0, 450)} {row.content.length > 450 && "..."}

                                        </Text>


                                    </Flex>
                                </Stack>
                            ))}


                        {((searchTerm || date) && notificationsData.length === 0) && (
                            <Flex alignItems={'center'}>
                                <Text >{t("Aucune notification correspondante n'a été trouvée.")}</Text>
                            </Flex>

                        )}

                        {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                        <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                            <Box flex="1">
                                <MyPagination
                                    paginationData={paginationData}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    PAGE_SIZE={pageSize}
                                />
                            </Box>

                            <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </Select>
                        </Flex>
                        {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

                    </Flex>


                </Flex>
            }

            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {isBulkAlert
                                ? t("êtes-vous sûr de vouloir supprimer les notifications sélectionnées ? Vous ne pourrez pas annuler cette action ultérieurement.")
                                : t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={isBulkAlert ? handleBulkDelete : () => handleDelete(id)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

        </Box>
    )
}

export default UserNotifications